// Proxy same-origin : Vite en dev/preview, fonction serverless Vercel en prod (`api/deezer/[...path].js`).
const DEEZER_PROXY_BASE = '/api/deezer';

function normalizeTrack(track) {
  if (!track?.id) return null;
  return {
    id: track.id,
    title: track.title,
    artist: track.artist?.name ?? 'Artiste inconnu',
    album: track.album?.title ?? null,
    cover: track.album?.cover_small ?? track.album?.cover_medium ?? null,
    coverMedium: track.album?.cover_medium ?? track.album?.cover_big ?? null,
    preview: track.preview ?? null,
  };
}

async function deezerFetch(endpoint, params = {}) {
  const qs = new URLSearchParams(params).toString();
  const url = `${DEEZER_PROXY_BASE}${endpoint}${qs ? `?${qs}` : ''}`;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`deezer_http_${response.status}`);
  }
  const payload = await response.json();
  if (payload?.error) {
    throw new Error(`deezer_api_${payload.error.type ?? 'error'}`);
  }
  return payload;
}

export async function searchDeezerTracks(query, limit = 6) {
  const q = (query ?? '').trim();
  if (!q) return [];

  const payload = await deezerFetch('/search', { q, limit: String(limit) });
  if (!Array.isArray(payload?.data)) return [];
  return payload.data.map(normalizeTrack).filter(Boolean);
}

/**
 * Fallback : récupère les infos riches d'un titre par son id (preview, cover).
 * Utilisé pour les anciennes suggestions qui n'avaient pas la preview stockée.
 */
export async function fetchDeezerTrackById(id) {
  if (!id) return null;
  try {
    const data = await deezerFetch(`/track/${encodeURIComponent(id)}`);
    if (!data || data.error) return null;
    return normalizeTrack(data);
  } catch {
    return null;
  }
}
